import axios from "axios";

export default {
    findMyself: () => axios.get("/api/dashboard/find_myself"),
    updateSidebarWidth: (obj) => axios.post("/api/dashboard/update_sidebar_width", obj),
    updateSidebarEnabled: (obj) => axios.post("/api/dashboard/update_sidebar_enabled", obj),
    read: () => axios.get("/api/dashboard/read"),
    find: (id) => axios.get(`/api/dashboard/find/${id}`),
    setZoom: (obj) => axios.post("/api/dashboard/set_zoom", obj),
    setTheme: (obj) => axios.post("/api/dashboard/set_theme", obj),
};
